import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetDirtyInputMutation implements CoreMutation {

  mutations = {
    [CORE_MUTATIONS_KEYS.setDirtyInput]: (localState: CoreState, dirtyInput: boolean) => {
      localState.dirtyInput = dirtyInput;
    }
  };
}
